import { DomainEvent, DomainEventType } from '../domain/event';
import { EventBusListener, EventBusUnsubscribe } from '../ports/event-bus';
import { DomEventBus } from './dom.event.bus';

export class VerboseDomEventBus extends DomEventBus {
    emit<E extends DomainEvent<object>>(event: E): void {
        // eslint-disable-next-line no-console
        console.debug('[event-bus::emit]', event);
        super.emit(event);
    }
    subscribe<E extends DomainEvent<object>, T extends DomainEventType>(
        type: T,
        listener: EventBusListener<E>
    ): EventBusUnsubscribe {
        // eslint-disable-next-line no-console
        console.debug('[event-bus::subscribe]', type);
        return super.subscribe(type, listener);
    }
}
